import Parse from "parse"
import { formatEmailToName } from "../utils"

export const getUserEventData = async (events, transformation) => {
    if (!events || !Array.isArray(events)) return []

    const userEvents = []
    
    // Fetch all unique user IDs
    const userIds = [...new Set(events.map(e => e.user?.objectId).filter(Boolean))]
    const userMap = new Map()
    
    if (userIds.length > 0) {
        try {
            const users = await new Parse.Query(Parse.User)
                .containedIn("objectId", userIds)
                .select("username", "firstName", "lastName")
                .find()
            
            users.forEach(user => {
                userMap.set(user.id, formatEmailToName(user.get("email") || user.get("username")) || "Utilisateur inconnu")
            })
        } catch (error) {
            console.error("Error fetching users:", error)
        }
    }

    events.forEach((event) => {
        const userId = event.user?.objectId
        const userName = userMap.get(userId) || "Utilisateur inconnu"
        const eventDate = event.date?.iso || event.date
        const formattedTime = eventDate ? new Date(eventDate).toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit" }) : null

        // Démarrage: status TODO -> IN_PROGRESS
        if (event.change === "status" && event.oldValue === "TODO" && event.value === "IN_PROGRESS") {
            userEvents.push({
                label: "Démarrer",
                user: userName,
                detail: `Fait à ${formattedTime}`,
                order: 1
            })
        }

        // Début de cuisson: startTemperature + COOKING
        if (event.change === "startTemperature" && transformation === "COOKING") {
            userEvents.push({
                label: "Début de cuisson",
                user: userName,
                detail: `Fait à ${formattedTime} - ${event.value}°`,
                order: 2
            })
        }

        // Fin de cuisson: endTemperature + COOKING
        if (event.change === "endTemperature" && transformation === "COOKING") {
            userEvents.push({
                label: "Fin de cuisson",
                user: userName,
                detail: `Fait à ${formattedTime} - ${event.value}°`,
                order: 3
            })
        }

        // Début de refroidissement: startTemperature + COOLING
        if (event.change === "startTemperature" && transformation === "COOLING") {
            userEvents.push({
                label: "Début de refroidissement",
                user: userName,
                detail: `Fait à ${formattedTime} - ${event.value}°`,
                order: 4
            })
        }

        // Fin de refroidissement: endTemperature + COOLING
        if (event.change === "endTemperature" && transformation === "COOLING") {
            userEvents.push({
                label: "Fin de refroidissement",
                user: userName,
                detail: `Fait à ${formattedTime} - ${event.value}°`,
                order: 5
            })
        }

        // Pesée: subStatus STEP_COMPLETION -> WEIGHT_VALIDATION
        if (event.change === "subStatus" && event.oldValue === "STEP_COMPLETION" && event.value === "WEIGHT_VALIDATION") {
            userEvents.push({
                label: "Pesée",
                user: userName,
                detail: `Fait à ${formattedTime}`,
                order: 6
            })
        }

        // Goutage: status TO_TEST -> DONE
        if (event.change === "status" && event.oldValue === "TO_TEST" && event.value === "DONE") {
            userEvents.push({
                label: "Goûtage",
                user: userName,
                detail: `Fait à ${formattedTime}`,
                order: 7
            })
        }
    })

    // Sort by order to maintain consistent display order
    return userEvents.sort((a, b) => a.order - b.order)
}

export const formatDate = (timestamp) => {
    if (!timestamp) return null
    const date = new Date(timestamp)
    return date.toLocaleDateString("fr-FR", { day: "2-digit", month: "2-digit", year: "numeric" })
}

export const formatTime = (timestamp) => {
    if (!timestamp) return null
    const date = new Date(timestamp)
    return date.toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit" })
}